import React, { useState } from 'react';

import { DownloadBottom } from '@videoblocks/react-icons';

import { Button } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Button/Button';
import { Text } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Text/Text';

const reactions = [
  {
    id: 'happy',
    alt: 'Satisfied with Video Edit',
    defaultIcon: `${__ASSETS_COMMON_IMAGES_URL__}/icons/feedback/happy.svg`,
    selectedIcon: `${__ASSETS_COMMON_IMAGES_URL__}/icons/feedback/happy-selected.svg`,
  },
  {
    id: 'neutral',
    alt: 'Neutral about Video Edit',
    defaultIcon: `${__ASSETS_COMMON_IMAGES_URL__}/icons/feedback/neutral.svg`,
    selectedIcon: `${__ASSETS_COMMON_IMAGES_URL__}/icons/feedback/neutral-selected.svg`,
  },
  {
    id: 'sad',
    alt: 'Dissatisfied with Video Edit',
    defaultIcon: `${__ASSETS_COMMON_IMAGES_URL__}/icons/feedback/sad.svg`,
    selectedIcon: `${__ASSETS_COMMON_IMAGES_URL__}/icons/feedback/sad-selected.svg`,
  },
];

const VideoEditResult = ({}) => {
  const [feedback, setFeedback] = useState('');
  const [selectedReaction, setSelectedReaction] = useState(null);

  return (
    <>
      <div className="mt-8 flex gap-2 items-center mb-8">
        <img
          className="h-8 w-8"
          src={`${__ASSETS_COMMON_IMAGES_URL__}/logos/storyblocks-icon.svg`}
          alt="Storyblocks Logo"
        />
        <Text fontSize="xl" className="m-0">
          Edit with AI
        </Text>
      </div>

      <Text fontSize="2xl">Preview and download your edited video below</Text>

      <Text fontSize="base" fontWeight="regular">
        A copy has also been sent to your email
      </Text>

      <Button
        iconPrefix={<DownloadBottom />}
        variant="primary"
        className="my-4 "
        buttonClassName="flex gap-2 items-center"
      >
        Download
      </Button>

      <div className="w-full h-1/3">
        {/* The video player component would go here */}
      </div>

      <Text fontSize="base" fontWeight="regular">
        Did this video meet your expectations?
      </Text>

      <div className="flex gap-4 mb-4">
        {reactions.map((reaction) => (
          <button
            key={reaction.id}
            onClick={() => setSelectedReaction(reaction.id)}
          >
            <img
              src={
                selectedReaction === reaction.id
                  ? reaction.selectedIcon
                  : reaction.defaultIcon
              }
              alt={reaction.alt}
              className="w-12 h-12"
            />
          </button>
        ))}
      </div>
      {selectedReaction && (
        <div className="w-full bg-gray-900 border-2 border-gray-700 rounded-3xl text-white mb-6 h-[100px]">
          <div className="p-4">
            <textarea
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Add additional details to help us improve your experience..."
              className="w-full bg-transparent border-0 resize-none outline-none placeholder-white text-sm h-24"
            />
            <div className="flex justify-end gap-3">
              <Button variant="outlined-light">Submit Feedback</Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoEditResult;
